export const getGroupedSkills = state => state.getIn(['skills', 'grouped'])
export const getSkillsList = state => state.getIn(['skills', 'list'])
